import { Box, Typography, useMediaQuery } from "@mui/material"
import { PageRowSection, PageSection, ReferanceCard, VideoCard } from "../../components"
import { Trans, useTranslation } from "react-i18next"
import { theme } from "../../../../utils"
import PathwayImage1 from '../../../../assets/images/other/pathway_mobile.png'
import TransMsg from './transMessage'
import { complementPathwayVideoUrl, complementPathwayThumbnailUrl } from "../../../../assets/data"
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"
import { imageMobileTooltipMakerData, imageTooltipMakerData } from "../../../../assets/data/educationHub/complementPathway"

const ComplementPathway = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))

    return (
        <Box>
            <VideoCard
                mainTitle={t(TransMsg.WATCH_AND_DISCOVER)}
                description={t(TransMsg.DISCOVER_DESCRIPTION)}
                videoURL={complementPathwayVideoUrl}
                thumbnailURL={complementPathwayThumbnailUrl}
                enableDownload={false}
            />
            <PageRowSection
                title={t(TransMsg.PIVOTAL_PLAYER)}
                sectionWrapperSx={{ pb: "87px" }}
                rightElement={
                    <Typography sx={{ ...theme.typography.components.sectionDescription }}>
                        <Trans
                            i18nKey={t(TransMsg.PIVOTAL_DESCRIPTION)}
                            components={{ br: <br />, sup: <sup /> }} />
                    </Typography>
                }
            />
            <PageSection
                description={t(TransMsg.IMAGE_CAPTION)}
                descriptionSx={{ mt: "0px" }}
                sectionCardSx={{ py: isMobileX ? "0px" : "15px", px: isMobileX ? "0px" : "23px" }}
                containerBoxSx={{ px: "13px" }}
                sectionImgUrl={PathwayImage1}
                imageStyle={{ width: isMobileX ? "180%" : "100%" }}
                tooltipMarkers={isMobileX ? imageMobileTooltipMakerData : imageTooltipMakerData}
            />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
                wrapperSx={{ py: "27px" }}
            />
        </Box>
    )
}

export default ComplementPathway